import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import styles from './index.css'
import moment from 'moment-timezone'

const { GMAPS_API_KEY } = process.env


export default class GPSDataMap extends React.Component {
  
  static propTypes = {
    sessions: PropTypes.array.isRequired
  }

  constructor(props) {
    super(props)
    this.mapLoaded = this.mapLoaded.bind(this)
    this.state = {
    }
  }

  componentDidMount() {
    console.log("componentDidMount")
    let formattedSessions = this.props.sessions.map(e => {
      return {
        ...e, 
        start_lng: e.start_lng && parseFloat(e.start_lng),
        start_lat: e.start_lat && parseFloat(e.start_lat),
        end_lng: e.end_lng && parseFloat(e.end_lng),
        end_lat: e.end_lat && parseFloat(e.end_lat)
      }
    })
    this.setState({ 
      sessions: formattedSessions
    })

    this.callbackName = '_GoogleMapsApi.mapLoaded'
    if (!window._GoogleMapsApi) {
      window._GoogleMapsApi = this
      window._GoogleMapsApi.mapLoaded = this.mapLoaded.bind(this)
    }
    if (!document.getElementById('gmapsScript')) {
      const s = document.createElement('script')
      s.id='gmapsScript'
      s.src = `//maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&callback=${this.callbackName}`;
      s.async = true
      document.body.appendChild(s)
    } else {
      setTimeout(this.mapLoaded, 100)
    }

    const el = document.getElementById('MapContainer')
  }

  componentWillUnmount() {
    //document.body.removeChild(this.script)
  }

  mapLoaded() {
    console.log("sessions", this.state.sessions)
    const opts = {
      zoom: 6
    }
    for (let s of this.state.sessions) {
      if (s && s.start_lat && s.start_lng) {
        opts.center = {
          lat : s.start_lat,
          lng : s.start_lng 
        }
        break;
      }
      if (s && s.end_lat && s.end_lng) {
        opts.center = {
          lat : s.end_lat,
          lng : s.end_lng 
        }
        break;
      }
    }
    if (!opts.center) {
      return this.setState({ missingPositions: true })
    }
    this.map = new window.google.maps.Map(document.getElementById('MapContainer'), opts)

    this.markers = []
    for (let s of this.state.sessions) {

      if (s.start_lat && s.start_lng) {
        var marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(s.start_lat, s.start_lng),
          map: this.map,
          title: s.start_time
        })
        this.markers.push(marker)
      }

      if (s.end_lat && s.end_lng) {
        var marker = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(s.end_lat, s.end_lng),
          map: this.map,
          title: s.end_time
        })
        this.markers.push(marker)
      }

    }
  }

  render() {
    return (
      <Fragment>
        {
          !this.state.missingPositions && !this.state.missingSessionData &&
            <div id='MapContainer'>
            </div>
        }
        {
          this.state.missingPositions &&
            <Fragment>
              <h1>Error</h1>
              <div style={{fontSize: '1.6rem'}}>Positions are missing</div>
            </Fragment>
        }
        {
          this.state.missingSessionData &&
            <Fragment>
              <h1>Error</h1>
              <div style={{fontSize: '1.6rem'}}>Missing session data</div>
            </Fragment>
        }
      </Fragment>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/GPSDataMap/index.jsx